var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.imageSrc,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }